export default "__VITE_ASSET__Cu65wq_E__"